const REGEX = {
    TELEPHONE_NUMBER: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    HTTP_URL: /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/,
    EMPLOYER_NAME: /^\S.{0,73}$/,
    PASSWORD_STRENGTH_ARRAY: [/(?=.*[A-Z])/, /(?=.*[a-z])/, /(?=.*[0-9])/, /([^A-Za-z0-9])/],
    NINO_NUMBER: /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])(?:\s*\d\s*){6}([A-D]|\s)$/
};

export default REGEX;
